import { useConfigStore } from '../store/configStore';
import { MetoroConfig } from '../types/config';

export function useMetoroConfig() {
    const { config, isLoading, error, isInitialized } = useConfigStore();
    return { config, isLoading, error, isInitialized };
}

export function useIsFeatureEnabled(feature: keyof MetoroConfig) {
    const { config } = useConfigStore();
    return config[feature];
} 